import type React from 'react'
import { classNames } from '@/utils/classNames'
interface BadgeProps {
    icon?: React.ReactNode
    label: React.ReactNode
    className?: string
}

export function Badge({ icon, label, className = '' }: BadgeProps) {
    return (
        <div
            className={classNames(
                'flex items-center rounded-xl bg-black/32 px-3 py-2 text-sm text-white backdrop-blur-xs',
                className
            )}
        >
            {icon && <span className={label ? 'mr-1' : ''}>{icon}</span>}
            <span>{label}</span>
        </div>
    )
}
